export default __webpack_public_path__ + "static/IN-8003_Quick_Installation_01-a5f5f6fb17722349945501a52bad28fd.webp";